<template>
  <div v-if="label">
    <h2 class="subtitle">{{label.titles.title}} <Info multilined bottom :tooltipText="label.titles.titleTooltip"/></h2>

    <div>
      <!-- Table -->
      <div class="table-container">
        <table class="table is-hoverable">
          <thead>
            <tr>
              <th>{{label.forms.name}}</th>
              <th>{{label.forms.ean}}</th>
              <!-- <th>{{label.forms.energy}}</th> -->
              <!-- <th>{{label.forms.unit}}</th> -->
              <!-- <th>{{label.forms.type}}</th> -->
              <!-- <th>{{label.forms.source}}</th> -->
              <!-- <th>{{label.forms.permissions}}</th> -->
              <th class="has-text-centered"><div class="large-col">{{label.forms.actions}}</div></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="clipod of clipods" :key="clipod.pod.id">
              <td>{{clipod.podCustomName}}</td>
              <td>{{clipod.pod.EAN ? clipod.pod.EAN : '--'}}</td>
              <!-- <td>{{clipod.pod.energy.energyName}}</td> -->
              <!-- <td>{{clipod.pod.energy.inputUnit}}</td> -->
              <!-- <td>{{clipod.pod.energy.hasCumulativeIndexes ? label.forms.indexCumul : label.forms.indexNoCumul}}</td> -->
              <!-- <td>{{clipod.pod.source === 'user' ? "Client" : "GRD"}}</td> -->
              <!-- <td>{{getPodAccessRightAsText(clipod)}}</td> -->
              <td class="has-text-centered">
                <a class="button is-outlined is-dark is-small" @click="openDetailModal(clipod)">{{label.buttons.details}}</a>
                <a v-if="isUserAllowedToEditPod(clipod)" class="button is-outlined is-info is-small" style="margin-left: 10px;" @click="openEditModal(clipod)">{{label.buttons.edit}}</a>
                <a v-else disabled class="button is-outlined is-info is-small" style="margin-left: 10px;">{{label.buttons.edit}}</a>
                <a
                  class="button is-outlined is-danger is-small"
                  style="margin-left: 10px;"
                  @click="showConfirmDeletePodModal = true; clipodToDelete=clipod">
                  <!-- @click="deletePOD(clipod.pod.id)" -->
                  {{label.buttons.delete}}
                </a>
                <!-- <a
                  v-if="clipod.pod.source === 'user' && isUserAllowedToDeletePod(clipod)"
                  class="button is-outlined is-danger is-small"
                  style="margin-left: 10px;"
                  @click="deletePOD(clipod.pod.id)">
                  {{label.buttons.delete}}
                </a>
                <a v-else
                  disabled
                  class="button is-outlined is-danger is-small"
                  style="margin-left: 10px;">
                  {{label.buttons.delete}}
                </a> -->
              </td>
            </tr>
            <tr v-if="!clipods || clipods.length == 0">
              Vous n'avez pas encore de point d'accès associé à votre compte
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Details Modal -->
    <div class="modal" :class="{ 'is-active': showDetailModal }">
      <div class="modal-background" @click="showDetailModal = false"></div>
      <div class="modal-content" v-if="selectedClipod">
        <div class="box">
          <h1 class="title">{{label.titles.titleDetail}} 
            <!-- ({{selectedClipod.podCustomName}}) -->
          </h1>
          <!-- <p v-if="selectedClipod.pod.source != 'user'" style="margin-bottom: 1rem;">{{label.texts.grdPod}}</p> -->

          <div class="box-section">
            <strong>{{label.forms.address}} :</strong>
            <p>{{selectedClipodAddress}}</p>
          </div>

          <div class="box-section">
            <strong>{{label.forms.registers}} :</strong>

            <div class="table-container-register">
              <table class="table is-hoverable">
                <thead>
                  <tr>
                    <!-- <th>{{label.forms.name}}</th> -->
                    <th>{{label.forms.timeframe}}</th>
                    <th>{{label.forms.meterNumber}}</th>
                    <th>{{label.forms.type}}</th>
                    <th>{{label.forms.activity}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="variable of selectedClipod.pod.variable" v-bind:key="variable.id">
                  <!-- Exclude PWR and PWR_EX variables from lising of variables -->
                    <template v-if="variable.meter && variable.timeframe !== 'PWR' && variable.timeframe !== 'PWR_EX'">
                      <!-- <td>{{getRegisterFriendlyName(variable.name)}}</td> -->
                      <td>{{getTimeframeFriendlyName(variable.timeframe)}}</td>
                      <td>{{variable.meter ? variable.meter : '--'}}</td>
                      <td>{{label.forms["mappingDirection_" + variable.direction]}}</td>
                      <td>{{variable.validTo ? 'Inactif' : 'Actif'}}</td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="field is-grouped">
            <p class="control">
              <a class="button is-light" @click="showDetailModal = false">{{label.buttons.close}}</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit/Create Modal -->
    <div class="modal" :class="{ 'is-active': showEditModal || showCreateModal }">
      <div class="modal-background" @click="cancelModal()"></div>
      <div class="modal-content">
        <div class="box">
          <div class="title">{{showCreationForm ? label.titles.createPod : "Modifier le nom de mon point"}}</div>
          <!-- <p v-if="selectedClipod && selectedClipod.pod.source != 'user'" style="margin-bottom: 1rem;">{{label.texts.grdPod}}</p> -->
          <div v-if="showCreationForm && !manualCreation">
            <ul>{{label.texts.twoChoices}} :
              <li>
                {{label.texts.askPodLink}}<br>
                <a class="button is-outlined is-info" style="margin-top: .75rem;" @click="openAskModal()">{{label.buttons.podLink}}</a>
              </li>
              <li>
                {{label.texts.askManualCreation}}<br>
                <a class="button is-outlined is-info" style="margin-top: .75rem;" @click="manualCreation = true">{{label.buttons.manualCreation}}</a>
              </li>
            </ul>
          </div>

          <!-- old version for edit modal -->
          <!-- <form @submit.prevent="submitPod" v-show="showEditModal || manualCreation"> -->
          <!-- version where you can only change the pod name -->
          <form @submit.prevent="changePodName" v-show="showEditModal">

            <!-- Nom POD -->
            <div class="field">
              <label class="label">{{label.forms.personalizedName}} * <Info multilined :tooltipText="label.forms.personalizedNameTooltip"/></label>
              <div class="control">
                <input required class="input" type="text" maxlength="200" v-model="customName">
              </div>
            </div>

            

            <!-- Confirm/Cancel -->
            <!-- <p>* : {{label.texts.mandatory}}</p> -->
            <div class="field is-grouped">
              <p class="control">
                <button class="button is-primary" type="submit">{{label.buttons.save}}</button>
              </p>
              <p class="control">
                <a class="button is-light" @click="cancelModal()">{{label.buttons.cancel}}</a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Ask Modal -->
    <div class="modal" :class="{ 'is-active': showAskModal }">
      <div class="modal-background" @click="cancelModal()"></div>
      <div class="modal-content">
        <div class="box">
          <div class="title">{{label.titles.titleLink}}</div>
          <p style="margin-bottom: 1rem;">{{label.texts.infoPodLink}}</p>
          <form @submit.prevent="submitPodRequest">
            <!-- <input id="hp-portal-consent" type="file">
            <button @click="sendConsentFile">envoyer le fichier de consentement</button> -->
            <p class="subtitle" style="margin-top: 2rem;">{{label.forms.clientInfo}}</p>

            <div class="horizontal-wrapper">
              <!-- Prénom -->
              <div class="field">
                <label class="label">
                  {{label.forms.firstName}}*
                  <Info multilined tooltipText="Prénom du signataire du contrat"/>
                </label>
                <div class="control">
                  <input required class="input input-large" type="text" maxlength="50" v-model="podRequestForm.firstName">
                </div>
              </div>

              <!-- Nom -->
              <div class="field">
                <label class="label">
                  {{label.forms.lastName}}*
                  <Info multilined tooltipText="Nom de famille du signataire du contrat"/>
                </label>
                <div class="control">
                  <input required class="input input-large" type="text" maxlength="100" v-model="podRequestForm.name">
                </div>
              </div>
            </div>

            <div class="horizontal-wrapper">
              <!-- Téléphone / GSM -->
              <!-- <div class="field">
                <label class="label">{{label.forms.phone}}</label>
                <div class="control">
                  <input class="input input-large" type="text" maxlength="50" v-model="podRequestForm.phoneNumber">
                </div>
              </div> -->

              <!-- Email -->
              <div class="field">
                <label class="label">{{label.forms.email}}</label>
                <div class="control">
                  <input disabled class="input input-large" type="email" maxlength="200" v-model="this.user.email">
                </div>
              </div>
            </div>

            <!-- <div class="field">
              <label class="checkbox">
                <input type="checkbox" v-model="podRequestForm.isDelegation">
                {{label.forms.isDelegation}}
              </label>
            </div> -->

            <div v-if="podRequestForm.isDelegation">
              <div class="horizontal-wrapper">
                <!-- Prénom isDelegation -->
                <div class="field">
                  <label class="label">{{label.forms.proprioFirstName}}*</label>
                  <div class="control">
                    <input required class="input input-large" type="text" maxlength="200" v-model="podRequestForm.ownerFirstName">
                  </div>
                </div>

                <!-- Nom isDelegation -->
                <div class="field">
                  <label class="label">{{label.forms.proprioLastName}}*</label>
                  <div class="control">
                    <input required class="input input-large" type="text" maxlength="100" v-model="podRequestForm.ownerLastName">
                  </div>
                </div>
              </div>

              <div class="horizontal-wrapper">
                <!-- Téléphone / GSM isDelegation -->
                <div class="field">
                  <label class="label">{{label.forms.proprioPhone}}*</label>
                  <div class="control">
                    <input required class="input input-large" type="text" maxlength="50" v-model="podRequestForm.ownerPhoneNumber">
                  </div>
                </div>

                <!-- Email isDelegation -->
                <div class="field">
                  <label class="label">{{label.forms.proprioEmail}}*</label>
                  <div class="control">
                    <input required class="input input-large" type="email" v-model="podRequestForm.ownerEmail">
                  </div>
                </div>
              </div>
            </div>

            <p class="subtitle" style="margin-top: 2rem;">{{label.forms.podInfo}}</p>

            <div class="field">
              <input type="checkbox" v-model="confirmedIsSmartMeter">
              Je confirme que c'est un compteur communicant 
              <Info multilined tooltipText="Un doute ? Consultez les photos de ce type de compteurs dans la section 'compteurs communicants' de la page d'accueil."/>
            </div>

            <div class="horizontal-wrapper">
              <!-- GRD -->
              <div class="field" style="margin-right: 10px;">
                <label class="label">Gestionnaire de réseau*</label>
                <div class="control">
                  <div class="select">
                    <select name="GRD" required v-model="podRequestForm.dgo">
                      <option :value="null">-</option>
                      <option :key="dgo" :value="dgo" v-for="dgo of dgoList">{{ dgo }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- EAN -->
              <div class="field">
                <label class="label">
                  N° EAN (18 chiffres) *
                  <Info multilined tooltipText="Suite de 18 chiffres qui identifie votre point d'accès. Vous pouvez le retrouver dans vos contrats d'énergie. Ex: 541455700000078361"/>
                </label>
                <div class="control">
                  <input required class="input input-large" type="text" pattern="\d{18,18}" maxlength="18" v-model="podRequestForm.ean">
                </div>
              </div>

              <!-- Énergie -->
              <!-- <div class="field">
                <label class="label">{{label.forms.energy}}*</label>
                <div class="control">
                  <div class="dropdown" :class="{'is-active': energyDropAskActive}">
                    <div class="dropdown-trigger">
                      <button
                        class="button"
                        type="button"
                        @click="energyDropAskActive = !energyDropAskActive"
                        @blur="energyDropAskActive = false">
                        <span>{{podRequestForm.energyName}}</span>
                        <span class="icon is-small"><awesome-icon icon="angle-down" aria-hidden="true"/></span>
                      </button>
                    </div>
                    <div class="dropdown-menu " role="menu">
                      <div class="dropdown-content">
                        <a
                          class="dropdown-item"
                          v-for="energy of energies"
                          :key="energy.id"
                          @mousedown="podRequestForm.energyName = energy.energyName"
                        >
                          {{energy.energyName}}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- Compteur -->
              <div class="field">
                <label class="label">
                  N° de compteur (8 chiffres) *
                  <Info multilined tooltipText="Suite de 8 chiffres qui identifie votre compteur. Vous pouvez le retrouver sur votre compteur. Ex: 89547617"/>
                </label>
                <div class="control">
                  <input required class="input input-medium" type="text" pattern="\d{8,8}" maxlength="8" v-model="podRequestForm.meter">
                </div>
              </div>
            </div>

            <p class="subtitle" style="margin-top: 2rem;">{{label.forms.podAddress}}</p>

            <div class="horizontal-wrapper">
              <!-- Rue -->
              <div class="field">
                <label class="label">{{label.forms.street}}*</label>
                <div class="control">
                  <input required class="input input-large" type="text" maxlength="50" v-model="podRequestForm.ownerStreetName">
                </div>
              </div>

              <!-- Numéro -->
              <div class="field">
                <label class="label">{{label.forms.number}}*</label>
                <div class="control">
                  <input required class="input input-small" type="text" maxlength="6" v-model="podRequestForm.ownerStreetNumber">
                </div>
              </div>

              <!-- N° de boite -->
              <div class="field">
                <label class="label">{{label.forms.box}}</label>
                <div class="control">
                  <input class="input input-small" type="text"  maxlength="3" v-model="podRequestForm.ownerBoxNumber">
                </div>
              </div>
            </div>

            <div class="horizontal-wrapper">
              <!-- Code postal -->
              <div class="field">
                <label class="label">{{label.forms.zipcode}}*</label>
                <div class="control">
                  <input required class="input input-small" type="text" maxlength="6" v-model="podRequestForm.ownerPostalCode">
                </div>
              </div>

              <!-- Ville -->
              <div class="field">
                <label class="label">{{label.forms.city}}*</label>
                <div class="control">
                  <input required class="input input-large" type="text" maxlength="50" v-model="podRequestForm.ownerLocality">
                </div>
              </div>

              <!-- Pays -->
              <!-- <div class="field">
                <label class="label">{{label.forms.country}}*</label>
                <div class="control">
                  <input required class="input input-medium" type="text" maxlength="100" v-model="podRequestForm.ownerCountry">
                </div>
              </div> -->
            </div>

            <p class="subtitle" style="margin-top: 2rem;">{{label.forms.comment}}</p>
            <textarea maxlength="300" v-model="podRequestForm.comment" class="textarea has-fixed-size" :placeholder="label.forms.commentText"></textarea>

            <div class="field" id="gdpr-zone">
              <input type="checkbox" v-model="agreedToGDPR">
              J'ai pris connaissance des mentions d'informations prévues par les articles 12, 13 et 14 du RGPD repris
              <a href="/gdpr" target="_blank">sous le lien suivant</a> 
            </div>

            <div
              v-if="showAddPodReqErrorMessage"
              class="notification is-danger">
              Ce numéro d'EAN est lié à une demande qui a été acceptée ou est encore en attente
            </div>

            <!-- <div v-if="formErrors.length > 0" class="notification is-danger">
                Veuillez résoudre ces erreurs :
                <p style="margin-top: 8px" v-for="error of formErrors" :key="error">
                    <strong>{{error}}</strong>
                </p>
            </div> -->
            
            <!-- Confirm/Cancel -->
            <div class="field is-grouped">
              <p class="control">
                <button :disabled="uploadingPodRequest || !agreedToGDPR || !confirmedIsSmartMeter" class="button is-primary" type="submit">{{label.buttons.save}}</button>
              </p>
              <p class="control">
                <a class="button is-light" @click="cancelModal()">{{label.buttons.cancel}}</a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>


      <!-- Mes demandes d'ajout de point d'accès GRD -->
      <!-- <strong>{{label.texts.myLinks}}</strong>
      <ul>
        <li v-for="podRequest of podRequests" :key="podRequest.id">
          - {{podRequest.EAN}} &rarr; {{podRequest.delegatedFirstName}} {{podRequest.delegatedLastName}}
        </li>
      </ul> -->
    <!-- Table for admin action history -->
    <div id="hp-requests-table">
        <h3 class="subtitle">Mes demandes d'accès</h3>
        <div class="table-container">
          <table class="table is-hoverable">
            <thead>
                <tr>
                    <th>EAN</th>
                    <th>Date de la demande</th>
                    <th>Statut</th>
                    <th>Raison du refus</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                  <td id="add-pod-btn"
                    class="add-pod has-text-centered"
                    colspan="20"
                    @click="openAskModal()">
                    <awesome-icon class="button-icon" icon="plus"/>
                    Demander accès à un point
                  </td>
                </tr>
                <tr :key="podRequest.id" v-for="podRequest of podRequests">
                    <td>{{ podRequest.EAN }}</td>
                    <td>{{ formatDateToText(podRequest.requestDate) }}</td>
                    <td>{{ getHpReqLastActionText(podRequest) }}</td>
                    <td>
                      {{getHpReqLastActionRefuseReason(podRequest)}}
                    </td>
                </tr>
            </tbody>
          </table>
        </div>
    </div>

    <ConfirmActionModal
      ref="confirmActionModal"
      :isActive="showConfirmDeletePodModal"
      message="Supprimer ce point d'accès ? Vous perdrez accès à toutes les données associées."
      @close="showConfirmDeletePodModal = false; clipodToDelete=null"
      @confirm="deletePOD"
    />
  </div>
</template>
<script>
import { KNOWN_TIMEFRAMES } from '../helpers/known-timeframes'
import { AddressService, PODService, EnergyService, PodRequestService } from '../services'
import { sortRegisters, DB_COLLECTIONS, getDelegationRight, whatCanDelegatedUserDo, getRegisterFriendlyName, TIMEFRAME_FRIENDLY_MAPPING } from '../helpers'
import Info from '../components/Info.vue'
import ConfirmActionModal from '../components/ConfirmActionModal.vue'
// import { Datetime } from 'vue-datetime';
import { mapState, mapActions } from 'vuex'
import moment from 'moment'

export default {
  components: {
    // Datetime,
    Info,
    ConfirmActionModal
  },
  data() {
      return {
          confirmedIsSmartMeter: false,
          showConfirmDeletePodModal: false,
          clipodToDelete: null,
          agreedToGDPR: false,
          uploadingPodRequest: false,
          showAddPodReqErrorMessage: false,
          showIncorrectPodSetupMsg: false,
          incorrectPodSetupMessage: null,
          energies: null,
          // dgo list
          dgoList: ["REW","AIEG","AIESH"],
          // todo changer par A+, A-, compensation
          availableDirections: ["prelevement", "injection"],
          availableTimeframes: [],

          clipods: null,
          selectedClipod: null,

          addresses: [],
          showAddressForm: false,
          addressForm: {
              country: '',
              postalCode: '',
              localityName: '',
              streetName: '',
              streetNumber: '',
              boxNumber: '',
              customName: '',
          },

          customErrors: '',

          showCreationForm: true,
          clipodInModif: null,
          // pod form
          customName: '',
          addressID: '',
          energyID: null,
          energyName: '',
          ean: '',
          validFrom: '',
          registers: [
            {name: '', timeframe: '', meter: '', direction: 'prelevement', id: '', source: 'user'}
          ],
          deletedRegisters: [],

          // pod request form
          podRequestForm: null,
          // existing pod requests
          podRequests: null,
          showDetailModal: false,
          showEditModal: false,
          locationDropActive: false,
          energyDropActive: false,
          registryDropActive: false,
          timeframeDropActive: false,
          showCreateModal: false,
          showAskModal: false,
          energyDropAskActive: false,
          dgoDropAskActive: false,
          addressChosen: "",
          manualCreation: false
      }
  },
  computed: {
      ...mapState("account", ["user"]),
      ...mapState({ label: state => state.labels.pods }),
      blockLocationChange() {
        return this.showEditModal && this.clipodInModif && this.clipodInModif.isDelegatedAccess
      },
      unitOfSelectedEnergy() {
          if(!this.energies)
              return "";
          const energy = this.energies.find(e => e.energyName == this.energyName)
          return energy ? energy.inputUnit : ""
      },
      selectedClipodAddress() {
          if(!this.selectedClipod || !this.selectedClipod.pod.location)
              return "/";
          const address = this.selectedClipod.pod.location;
          return `${address.customName} : ${address.country} ${address.postalCode} ${address.localityName} ${address.streetName} ${address.streetNumber}
           ${address.boxNumber ? address.boxNumber : ''}`
      },
  },
  methods: {
      ...mapActions("labels", ["getLabel"]),
      // sendConsentFile() {
      //   const consentFile = document.getElementById('hp-portal-consent').files[0]
      //   PODService.uploadConsentFile({consentFile: consentFile}).then(() => {})
      // },
      sortRegisters(variables) {
        return sortRegisters(variables)
      },
      getTimeframeFriendlyName(timeframe) {
        return TIMEFRAME_FRIENDLY_MAPPING[timeframe]
      },
      getRegisterFriendlyName(registerName) {
        return getRegisterFriendlyName(registerName)
      },
      updateSelectedDGO(event) {
        this.podRequestForm.dgo = event.target.value
      },
      formatDateToText(date) {
          return moment(date).format('DD-MM-YYYY')
      },
      getHpReqLastActionRefuseReason(hpReq) {
          if(!(hpReq.actionHistory && hpReq.actionHistory.length > 0))
            return null
          return hpReq.actionHistory[hpReq.actionHistory.length-1].refuseRequestReason
      },
      getHpReqLastActionText(hpReq) {
          if(hpReq.endOfContractDetected)
            return 'Fin de contrat détectée'
          if(!hpReq.actionHistory || hpReq.actionHistory.length == 0)
              return 'En attente'
          return hpReq.actionHistory[hpReq.actionHistory.length-1].accepted ? 'Accepté' : 'Refusé'
      },
      isUserAllowedToEditPod(clipod) {
        if(!clipod.isDelegatedAccess)
          return true
        const delegationRight = getDelegationRight(clipod)
        if(!delegationRight)
          return false
        const meteringPermissions = whatCanDelegatedUserDo({ collection: DB_COLLECTIONS.POD, delegationRight: delegationRight })
        return meteringPermissions && meteringPermissions.canModify
      },
      isUserAllowedToDeletePod(clipod) {
        if(!clipod.isDelegatedAccess)
          return true
        const delegationRight = getDelegationRight(clipod)
        if(!delegationRight)
          return false
        const meteringPermissions = whatCanDelegatedUserDo({ collection: DB_COLLECTIONS.POD, delegationRight: delegationRight })
        return meteringPermissions && meteringPermissions.canDelete
      },
      getPodAccessRightAsText(clipod) {
        if(clipod.isDelegatedAccess) {
          return clipod.hasWritePermission ? this.label.texts.complete : this.label.texts.readonly
        }
        else {
          return this.label.texts.complete
        }
      },
      async loadPodRequests() {
          // PODService.loadPodRequests(this.user._id).then(podRequests => {
          //     this.podRequests = podRequests;
          // });
          let response = await PodRequestService.getUserPodRequests({ userID: this.user._id, pageIndex: 0, nbElPerPage: 20 })
          this.podRequests = response?.podRequests || []
      },
      resetPodRequestForm() {
          this.showAddPodReqErrorMessage = false
          this.agreedToGDPR = false
          this.confirmedIsSmartMeter = false
          this.podRequestForm = {
              // user infos
              name: '',
              firstName: '',
              phoneNumber: '',
              email: '',
              // owner infos
              isDelegation: false,
              ownerLastName: '',
              ownerFirstName: '',
              ownerPhoneNumber: '',
              ownerEmail: '',
              // pod infos
              dgo: null,
              ean: '',
              meter: '',
              energyName: this.energies ? this.energies[0].energyName : '',
              // owner address info
              ownerStreetName: '',
              ownerStreetNumber: '',
              ownerBoxNumber: '',
              ownerPostalCode: '',
              ownerLocality: '',
              ownerCountry: '',
              // comment
              comment: '',
          };
      },
      submitPodRequest() {
        this.showAddPodReqErrorMessage = false
        this.uploadingPodRequest = true
          PODService.addPodRequest(this.user._id, this.podRequestForm).then(
            (result) => {
              if(result && result.status == "ok") {
                this.showAskModal = false
                this.loadPodRequests()
                this.resetPodRequestForm()
              } else {
                this.showAddPodReqErrorMessage = true
              }
          })
          .finally(() => { this.uploadingPodRequest = false })
      },
      deletePOD() {
        PODService.deleteHeadpoint(this.user._id, this.clipodToDelete.pod.id).then((response) => {
          this.$refs.confirmActionModal.handleResult({ success: response.ID && response.ID != null })
          this.loadClipods()
        })
      },
      loadEnergies() {
          EnergyService.getEnergies().then(energies => {
              if(energies)
                  this.energyID = energies[0].id;
              this.energies = energies;
          });
      },
      formatAddress(address) {
          return `${address.customName} : ${address.streetName} ${address.streetNumber} ${address.boxNumber ? address.boxNumber: ''} ${address.postalCode} ${address.localityName}`;
      },
      selectAddressId(addressID) {
        this.addressID = addressID;
        if (addressID === '') {
          this.addressChosen = this.label.texts.noAddress;
        }
        else if (addressID === 'new') {
          this.addressChosen = this.label.texts.newAddress;
        }
        else {
          if(this.clipodInModif && this.clipodInModif.isDelegatedAccess) {
            return this.addressChosen = this.formatAddress(this.clipodInModif.pod.location)
          }
          this.addressChosen = this.formatAddress(this.addresses.find(address => address.id === addressID))
        }
      },
      loadClipods() {
          PODService.getActivePods(this.user._id, true).then(clipods => {
              if (!clipods) return;
              for(let clipod of clipods) {
                if(clipod.pod && clipod.pod.variable) {
                  clipod.pod.variable = this.sortRegisters(clipod.pod.variable)
                }
              }
              this.clipods = clipods;
              this.selectedClipod = this.clipods && this.clipods.length > 0 ? this.clipods[0] : null
          })
      },
      loadAddresses() {
          AddressService.getAddresses(this.user._id).then(addresses => {
              this.addresses = addresses;
          });
      },
      addRegister() {
          this.registers.push({name: '', timeframe: this.availableTimeframes[0], meter: '', direction: this.availableDirections[0], id: 'new', source: 'user'})
      },
      removeRegister(index) {
          // if modifying a pod, add deleted registers to an array
          if(!this.showCreationForm)
              this.deletedRegisters.push(this.registers[index]);
          this.registers.splice(index, 1);
      },
      openDetailModal(clipod) {
        this.selectedClipod = clipod;
        this.showDetailModal = true;
      },
      openEditModal(clipod) {
        this.clipodInModif = clipod;
        this.selectedClipod = clipod;
        this.energyID = clipod.pod.energy.id;
        this.setEditForm();
        this.selectAddressId(clipod.pod.location ? clipod.pod.location.id : '');
        this.showCreationForm = false;
        this.showEditModal = true;
      },
      openCreateModal() {
        this.clipodInModif = null;
        this.selectedClipod = null;
        this.clearForm();
        this.showCreationForm = true;
        this.showCreateModal = true;
      },
      openAskModal() {
        this.resetPodRequestForm();
        this.showCreateModal = false;
        this.showAskModal = true;
      },
      setEditForm() {
          this.deletedRegisters = [];
          this.customName = this.clipodInModif.podCustomName;
          this.addressID = this.clipodInModif.pod.location ? this.clipodInModif.pod.location.id : '';
          this.energyName = this.clipodInModif.pod.energy.energyName;
          this.ean = this.clipodInModif.pod.EAN;
          this.validFrom = this.clipodInModif.validFrom;
          this.registers = [];
          this.clipodInModif.pod.variable.forEach(v => {
              this.registers.push({ name: v.name, timeframe: v.timeframe, meter: v.meter, direction: v.direction, id: v.id, source: v.source, validTo: v.validTo ? v.validTo : null });
          });
      },
      submitPod() {
        this.customErrors = ''
        // Replace names
        let registersNames = {}
        this.registers.forEach((register, i) => {
          this.registers[i].name = register.name === "" ? register.timeframe : register.name
            // Count of names
            let count = register.name in registersNames
              ? registersNames[register.name] = registersNames[register.name] + 1
              : registersNames[register.name] = 0

            let name = register.name + `_${count}`
            // Increment count while there is a duplicate
            while(this.registers.some(reg => reg.name === name)) name = register.name + `_${++count}`
            this.registers[i].name = count === 0 ? register.name : name
        })

        const onlyActiveRegisters = this.registers.filter(r => r.id == 'new' || !r.validTo)
        if(!PODService.isPodSetupValid(onlyActiveRegisters.map(r => r.timeframe), onlyActiveRegisters.map(r => r.direction), this.energyName)) {
          this.showIncorrectPodSetupMsg = true
          return
        }

        if (this.showCreationForm) {
          this.showIncorrectPodSetupMsg = false
          // Create POD
          PODService.addPOD(
              this.user._id,
              this.ean,
              this.energyName,
              this.unitOfSelectedEnergy,
              this.customName,
              this.registers.map(r => r.name),
              this.registers.map(r => r.timeframe),
              this.registers.map(r => r.direction),
              this.registers.map(r => r.meter),
              moment(this.validFrom).format("YYYY-MM-DD"),
              !this.addressID || this.showAddressForm ? null : this.addressID,
              this.showAddressForm ? this.addressForm : {},
              this.energies.find(e => e.energyName == this.energyName).id)
            .then(() => {
              this.loadClipods()
            },
            error => {
              if(error.errorType === 'POD_SETUP') {
                this.showIncorrectPodSetupMsg = true
                this.incorrectPodSetupMessage = error.errorMsg
              }
            })
        }
        else {
          this.showIncorrectPodSetupMsg = false
          // Edit POD
          PODService.modifyPod(
              this.user._id,
              this.clipodInModif.pod.id,
              this.ean,
              this.energyName,
              this.unitOfSelectedEnergy,
              this.customName,
              this.registers.map(r => r.id),
              this.registers.map(r => r.name),
              this.registers.map(r => r.timeframe),
              this.registers.map(r => r.direction),
              this.registers.map(r => r.meter),
              this.deletedRegisters.map(dR => dR.id),
              !this.addressID || this.showAddressForm ? null : this.addressID,
              this.showAddressForm ? this.addressForm : {},
              this.registers.map(r => r.source)
            ).then(() => {
                this.loadClipods()
            })
        }

        this.cancelModal()
      },
      changePodName() {
        this.showIncorrectPodSetupMsg = false
        PODService.modifyPodName(this.user._id, this.clipodInModif.pod.id, this.customName).then(() => {
          this.loadClipods()
        })
        this.cancelModal()
      },
      cancelModal() {
        this.clearForm();
        this.customErrors = '';
        this.showEditModal = false;
        this.showCreateModal = false;
        this.showAskModal = false;
        this.manualCreation = false;
      },
      clearForm() {
          this.showIncorrectPodSetupMsg = false
          // pod creation form
          this.customName = '';
          this.ean = '';
          this.meter = '';
          this.addressID = '';
          this.validFrom = moment().format("YYYY-MM-DD");
          this.registers = [
              {name: '', timeframe: this.availableTimeframes[0], meter: '', direction: this.availableDirections[0], id: 'new', source: 'user'}
          ];
          this.addressForm = {
              country: '',
              postalCode: '',
              localityName: '',
              streetName: '',
              streetNumber: '',
              boxNumber: '',
              customName: '',
          };
          this.selectAddressId('');
          this.energyName = this.energies[0].energyName;
      },
  },
  created() {
      this.availableTimeframes = KNOWN_TIMEFRAMES
      this.getLabel({ view: 'pods' });
      this.resetPodRequestForm();
      this.validFrom = moment().format("YYYY-MM-DD");
      this.registers[0].direction = this.availableDirections[0]
      this.registers[0].timeframe = this.availableTimeframes[0]
      this.loadEnergies();
      this.loadClipods();
      this.loadAddresses();
      this.loadPodRequests();
  },
  watch: {
      addressID() {
          this.showAddressForm = this.addressID === 'new';
      }
  }
}
</script>

<style lang="scss" scoped>
#gdpr-zone {
margin-top: 2rem;
margin-bottom: 2rem;
}
#selected-dgo-text {
padding-left: 4px;
padding-right: 4px;
}
.horizontal-wrapper {
display: flex;
justify-content: space-between;
flex-wrap: wrap;
}

.input-small {
width: 100px !important;
}

.input-medium {
width: 200px !important;
}

.input-large {
width: 270px !important;
}

.field.is-grouped{
margin-top: 10px;
}

.box .box-section:not(:last-child) {
margin-bottom: 1rem;
}

.add-pod,
.add-registry {
cursor: pointer;

&:hover {
  background-color: #8796c9;
  color: white;
}
}

.align-center {
padding: 12px;
}

.large-col {
width: 250px;
}

ul {
list-style: inside;

& > * {
  margin-left: 1rem;
  margin-top: 1rem;
}
}
#hp-requests-table {
margin-top: 50px;
}
#add-pod-btn {
padding-left: 30px;
padding-right: 30px;
}
</style>